import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

export const trackLotteryClick = () => {
  return dispatchTrackingEvent(TrackingEvents.TrackingLotteryClick);
};
